import '../styling/NewQuotes.css'
import DashNav3 from '../components/DashNav3'
import {Link} from 'react-router-dom'
import { useQuotesContext } from "../hooks/useQuotesContext";
import {useState} from 'react';
import QuotesList from "../components/QuotesList";

const NewQuotes = () => {
    const {quotes} = useQuotesContext();
    const [searchTerm, setSearchTerm] = useState('');

    return ( 
        <div className="newclientscontainer">
        <DashNav3></DashNav3>
        <div className="newclientsright">
            <div className="newclientstop">
            <h1 className="text-3xl font-bold">Quotes</h1>
            <Link to="/createquote">
            <button className="btn btn-primary" id="newclientsbutton">New Quote</button>
            </Link>
            </div>
            <hr id="newline1"/>
            <div className="clientsdata">
                <div className="clientsdatadiv">
                <h1 className="text-2xl text-black" >All Quotes</h1>
                <div className="clientscount2">
                {quotes ? <h1 className="text-md text-black font-bold">{quotes.length}</h1> : <h1 className="text-md text-black font-bold">0</h1>}
                </div>
                </div>

        <div className="join">
                <div>
                <div>
                <input className="input input-bordered join-item" placeholder="Search" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}/>
                </div>
                </div>
                <div className="indicator">
                <button className="btn join-item">Search</button>
                </div>
            </div>
            </div>
            <QuotesList searchTerm={searchTerm}></QuotesList>
        </div>
    </div>
     );
}
 
export default NewQuotes;